import { Component, OnInit } from '@angular/core';
import { FormBuilder, Validators, FormGroup } from '@angular/forms';
import { User } from '../user';
import { AuthService } from '../auth.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';

@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.scss']
})
export class RegisterComponent implements OnInit {

  formRegister: FormGroup = this.fb.group({
    'firstname': ['', [Validators.required]],
    'lastname': ['', [Validators.required]],
    'email': ['', [Validators.required, Validators.email]],
    'password1': ['', [Validators.required, Validators.minLength(6)]],
    'password2': ['', [Validators.required, Validators.minLength(6)]],
  },
    { validator: this.matchingPasswords });

  loading: boolean = false;

  constructor(
    private router: Router,
    private fb: FormBuilder,
    private snackBar: MatSnackBar,
    private authService: AuthService
  ) { }

  ngOnInit(): void { }

  matchingPasswords(group: FormGroup) {
    if (group) {
      const password1 = group.controls['password1'].value;
      const password2 = group.controls['password2'].value;
      if (password1 == password2)
        return null;
    }
    return { matching: false };
  }

  onSubmit() {
    this.loading = true;

    const newUser: User = {
      firstname: this.formRegister.value.firstname,
      lastname: this.formRegister.value.lastname,
      email: this.formRegister.value.email,
      password: this.formRegister.value.password1
    }
    this.authService.register(newUser)
      .subscribe(
        () => {
          this.snackBar.open('Successfully registered. Use your new credentials to sign in.', 'OK', { duration: 2000 });
          this.router.navigateByUrl('/auth/login');
          this.loading = false;
        },
        (err) => {
          console.log(err)
          this.snackBar.open('Error. You are not registered', 'OK', { duration: 2000 });
          this.loading = false;
        }
      )
  }
}
